import { setBasePriceFun, setTotalPriceFun } from "@/store/price";

export const setPriceInfoFun = (res: any, queryParam: any) => {
	const priceInfo = {
		adultPrice: res.routing.adultPrice,
		adultTax: res.routing.adultTax,
		childPrice: res.routing.childPrice,
		childTax: res.routing.childTax,
		infantPrice: res.routing.infantPrice || 0,
		infantTax: res.routing.infantTax || 0,
	};
	setBasePriceFun(priceInfo);

	let totalPrice = (priceInfo.adultPrice + priceInfo.adultTax) * queryParam.adultNum;
	if (queryParam.childNum !== 0) {
		totalPrice = totalPrice + (priceInfo.childPrice + priceInfo.childTax) * queryParam.childNum;
	}
	if (queryParam.infantNum !== 0) {
		totalPrice = totalPrice + (priceInfo.infantPrice + priceInfo.infantTax) * queryParam.infantNum;
	}
	setTotalPriceFun(totalPrice);
};
